import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedAdjusterAttachedDocumentImagesQueryParamsType,
  GetDamagedAdjusterAttachedDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedDocumentImages/getDamagedAdjusterAttachedDocumentImagesQuery.type';
import { getBodyAdjusterAttachedDocumentImagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterAttachedDocumentImages/getBodyAdjusterAttachedDocumentImagesQueryFunction';

export const getDamagedAdjusterAttachedDocumentImagesFunction = (
  params: GetDamagedAdjusterAttachedDocumentImagesQueryParamsType,
): Promise<GetDamagedAdjusterAttachedDocumentImagesQueryResponseType> => {
  if (params.type === 'body') {
    return getBodyAdjusterAttachedDocumentImagesQueryFunction(params);
  }
  if (params?.type && params?.type === 'initial') {
    return fetchApi.get(
      `/initial/reports/${params.id}/images/adjuster/document/additional/`,
    );
  }
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/adjuster/images/additional/document/`,
    { params },
  );
};
